import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-discharged-itinerary',
  templateUrl: './discharged-itinerary.component.html'
})
export class DischargedItineraryComponent  {
  @Input() isTicketOpen: boolean;

}
